import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BaseDialogData } from "@app/shared/resources/dialog.interface";
export interface IDialogButton {
    text: string;
    buttonColor?: "warn" | "primary" | "accent";
    styleClass?: string;
    method: "close" | EventEmitter<any>;
}

export interface IDialogConfig {
    id: string;
    data: IDialogData;
    disableClose: boolean;
}

export interface IDialogData extends BaseDialogData {
    title: string;
    buttons: IDialogButton[];
    icon?: string;
    message?: string;
    messageStyleClass?: string;
    messageHint?: string;
    requiredInfo?: any[];
    properties?: Record<string, any>;
    loading?: boolean;
    loadingMessage?: string;
    isCloseShown?: boolean;
}

@Component({
    templateUrl: "./clare-dialog.component.html",
    styleUrls: ["./clare-dialog.component.scss"],
})
export class ClareDialogComponent {
    @Output() onDialogEvent: EventEmitter<any> = new EventEmitter<any>();

    @Input() isCloseShown = false;
    public relayRequiredInfo;
    public contentStyleClass = "left-to-right";
    constructor(public dialogRef: MatDialogRef<ClareDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: IDialogData) {
        this.isCloseShown = data?.isCloseShown;
    }

    handleEvent(methodName) {
        if (methodName && methodName === "close") {
            this.dialogRef.close();
        } else {
            methodName.emit(this.dialogRef);
        }
    }
    checkProperties() {
        if (this.data.properties) {
            return Object.keys(this.data.properties);
        }
    }
    onParameterUpdate($event) {
        this.relayRequiredInfo = $event;
    }

    onClose() {
        this.dialogRef.close();
    }
}
